import {connect} from 'react-redux';
import {SourceRegionContainer} from './SourceRegionContainer';
import {setMrssDefaultsAction} from '../mrss-defaults/Redux/MrssDefaultsActions';

export interface MrssDefaultsType {
    data: {
        territories: string[];
    }
}
export interface State {
    mrssDefaults: MrssDefaultsType
}

export const mapState = (state: State) => {
    const {mrssDefaults} = state;
    return {
        mrssDefaults,
    };
};

export const mapDispatch = {
    setMrssDefaults: setMrssDefaultsAction,
};

export default connect(mapState, mapDispatch)(SourceRegionContainer);
